module.exports = __webpack_public_path__ + "static/media/cc.c4fddbc2.svg";